import DeleteIcon from '@mui/icons-material/Delete'
import { useTheme } from '@mui/material'
import { DataGrid, GridActionsCellItem, GridColDef } from '@mui/x-data-grid'
import useDeletePersonById, { useGetAllPerson } from '@src/api/person-api'
import { Person } from '@src/types/Person'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

const paginationModel = { page: 0, pageSize: 100 }

const PersonDataTable = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const [data, isFetchingPersons] = useGetAllPerson()

  const [deletePerson] = useDeletePersonById()

  const columns = useMemo<GridColDef<Person>[]>(
    () => [
      {
        field: 'fullName',
        headerName: t('person.fullName'),
        sortable: false,
        width: 160,
        renderCell: (params) => (
          <Link
            to={'/people/' + params.row.id}
            style={{
              color: theme.palette.text.primary,
              textDecoration: 'none',
              fontSize: '16px',
            }}
          >
            {params.row.fullName}
          </Link>
        ),
        flex: 1.5,
      },
      { field: 'startDate', headerName: t('person.startDate'), width: 130, flex: 1, sortable: false },
      { field: 'email', headerName: t('person.email'), width: 130, flex: 1.2, sortable: false },
      {
        field: 'team',
        headerName: t('person.team'),
        width: 120,
        flex: 0.8,
        sortable: true
      },
      {
        field: 'actions',
        type: 'actions',
        getActions: (params) => [
          <GridActionsCellItem
            key="delete"
            icon={<DeleteIcon color="error" />}
            label="Delete"
            onClick={async () => await deletePerson(params.row.id)}
          />,
        ],
        headerName: '',
        width: 100,
        sortable: false,
        filterable: false,
      },
    ],
    [deletePerson, t, theme.palette.text.primary],
  )

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <DataGrid
        rows={data}
        columns={columns}
        initialState={{ pagination: { paginationModel } }}
        pageSizeOptions={[50, 100]}
        disableColumnMenu
        disableRowSelectionOnClick
        disableColumnResize
        loading={isFetchingPersons}
      />
    </div>
  )
}

export default PersonDataTable
